// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT: Belbin Team Roles — IPS Format
// ─────────────────────────────────────────────────────────────────────────────
import { SECTIONS, TOTAL_SECTIONS } from "./questions.js";
import { ROLES, ROLE_MAP, CLUSTERS, CLUSTER_MAP } from "./factors.js";
import { scoreBelbin } from "./scoring.js";
import { NINEBOX_CELLS } from "../../constants/competencies.js";

function buildAIPrompt(assessment, reportType) {
  const scales = assessment.scores || {};
  const ranked = Object.entries(scales)
    .sort((a,b) => b[1]-a[1])
    .map(([id,score]) => ({ id, score, role:ROLES.find(r=>r.id===id) }));

  const primary   = ranked[0];
  const secondary = ranked[1];
  const least     = ranked[ranked.length-1];
  const cell      = NINEBOX_CELLS.find(c=>c.x===assessment.perfBox&&c.y===assessment.potBox);

  const roleLines = ranked.map(({id,score,role}) =>
    `  • ${role?.name||id} (${id}): ${score}/10 — ${role?.cluster||""} cluster`
  ).join("\n");

  return `You are an expert occupational psychologist interpreting a Belbin Team Roles profile (IPS format).

${reportType==="hiring"
  ? "HIRING REPORT — assess team role fit and ideal team composition contribution."
  : "DEVELOPMENT REPORT — leverage primary roles, develop secondary roles, manage blind spots."}

INSTRUMENT: Belbin Team Roles — IPS Format (7 sections × 8 statements, 10-point allocation)
CANDIDATE: ${assessment.name} | ${assessment.role} | ${assessment.demo?.country||""}
PRIMARY ROLE: ${primary?.role?.name||"—"} (${primary?.score}/10)
SECONDARY ROLE: ${secondary?.role?.name||"—"} (${secondary?.score}/10)
LEAST PREFERRED: ${least?.role?.name||"—"} (${least?.score}/10)

ALL ROLE SCORES (1-10):
${roleLines}`;
}

const BELBIN = {
  id:          "belbin",
  name:        "Belbin Team Roles",
  shortName:   "Belbin",
  version:     "2.0-IPS",
  publisher:   "AXIS360 — Belbin-inspired IPS Format",
  description: "7-section forced-choice assessment using the IPS (Inventory of Personal Strengths) method. Distribute 10 points across 8 statements per section — revealing your natural team role preferences across 9 Belbin roles.",
  icon:        "👥",
  color:       "#0f766e",
  bg:          "#ccfbf1",

  // IPS format — not Likert
  totalQuestions: 56,   // 7 × 8 statements
  timeEstimate:   "12–15 min",
  scaleType:      "ips",   // <-- special format flag
  pagesOf:        1,        // one section per page
  totalPages:     TOTAL_SECTIONS,

  questions:   SECTIONS,   // sections array (not flat questions)
  scales:      ROLES,
  scaleMap:    ROLE_MAP,
  domains:     CLUSTERS,
  domainMap:   CLUSTER_MAP,

  nineboxAxes: {
    x: { label:"Action Orientation",  description:"Shaper + Implementer + Completer Finisher", scaleIds:["SH","IMP","CF"] },
    y: { label:"Thinking & Social",   description:"Thinking + Social cluster balance",          scaleIds:["PL","ME","SP","CO","TW","RI"] },
  },
  nineboxCells: NINEBOX_CELLS,
  competencies: null,

  score:         scoreBelbin,
  buildAIPrompt,

  answerFormat: {
    type:             "ips",
    pointsPerSection: 10,
    statementsPerSection: 8,
  },
};

export default BELBIN;
